<template>
  <header>
    <section class="top" :class="{ 'is-home': isHome }">
      <div class="content">
        <div class="tabs">
          <div
            class="tab"
            v-for="(tab, index) in tabs"
            :key="tab"
            :class="{ active: isActive(index) }"
          >
            <router-link :to="tabLink(index)">
              {{ tab }}
            </router-link>
            <hr class="underline" width="32px" />
          </div>
          <div class="tab">
            <a href="http://oa.cxstar.cn/cn/#/classify" target="_blank">古籍</a>
            <hr class="underline" width="32px" />
          </div>
        </div>
        <div v-if="isLogin" class="login">
          <router-link to="/MyWorkbench" :class="{ active: isPersonal }">
            {{ userName }}
          </router-link>
          <span class="line">|</span>
          <span @click="confirmLogout">注销</span>
        </div>
        <div v-else class="login">
          <span @click="doLogin">登录</span>
          <span class="line">|</span>
          <span @click="doSignUp">注册</span>
        </div>
      </div>
      <login-menu :showLogin="showLogin" :tab="loginTab" @close-dialog="closeDialog" />
    </section>
    <SearchBar />
  </header>
</template>

<script>
import LoginMenu from 'views/login/LoginMenu'
import SearchBar from './SearchBar.vue'

export default {
  name: '',
  components: {
    LoginMenu,
    SearchBar,
  },
  computed: {
    isPersonal() {
      return this.$route.meta.isPersonal
    },
    isHome() {
      const lowercasedPath = this.$route.path.toLowerCase()
      return lowercasedPath === '/home'
    },
    isLogin() {
      const token = localStorage.getItem('token') && localStorage.getItem('userruid')
      if (token) return true
      else return false
    },
    userName() {
      let name = this.lodash.get(this.userInfo, 'username', '')
      if (!name) return '个人中心'
      if (name.length > 7) return name.substring(0, 6) + '...'
      else return name
    },
  },
  data() {
    return {
      tabs: ['首页', '中文书目', '外文书目'],
      showLogin: false,
      loginTab: 0,
      customercode: '',
      userInfo: {},
    }
  },
  created() {
    this.customercode = localStorage.getItem('customerCode')
  },
  mounted() {
    if (!localStorage.getItem('token') && this.$route.path != '/loading') {
      this.getLoginIP()
    }
    this.getUserInfo()
  },
  methods: {
    //判断是否是ip用户
    getLoginIP() {
      this.$http({
        url: '/api/v1/user/ipLogin',
        method: 'GET',
      }).then((res) => {
        if (res.cxajaxrc == 0) {
          localStorage.setItem('token', res.returnvalue.token)
          localStorage.setItem('isIpUser', 'true')
          this.$message.success('IP登录成功')
          location.reload()
        } else {
          this.$router.replace({
            path: '/login',
          })
        }
      })
    },
    tabLink(index) {
      if (index === 0) return '/home'
      return {
        path: '/BookList',
        query: { type: index === 1 ? 'cxstar' : 'zkcx' },
      }
    },
    isActive(index) {
      const path = this.$route.path
      const type = this.$route.query.type || this.$route.query.db
      if (index === 0) return path === '/home' || type === 'search'
      if (index === 1) return type === 'cxstar'
      if (index === 2) return type === 'zkcx'
    },
    showPick(index) {
      const code = this.customercode
      if (index === 4) {
        if (!code && code == 1) {
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    },
    tabClick(tab) {
      if (tab === '首页') return this.$router.push('/home')
      this.$router.push('/BookList')
    },
    doLogin() {
      this.loginTab = 0
      sessionStorage.setItem('fromRouter', this.$route.fullPath)
      this.$router.push('/login')
      // this.showLogin = true
    },
    doSignUp() {
      this.$router.push('/register')
      // this.loginTab = 1
      // this.showLogin = true
    },
    closeDialog() {
      this.showLogin = false
    },
    // 确认是否注销
    confirmLogout() {
      this.$confirm('确定要注销吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.doLogout()
        })
        .catch(() => {
          return false
        })
    },
    doLogout() {
      this.$http.get('/api/v1/user/accountlogout').then((res) => {
        if (res.cxajaxrc == 0) {
          this.$message.success('您已成功注销')
          localStorage.clear()
          this.$router.push('/login')
        }
      })
    },
    getUserInfo() {
      if (!localStorage.getItem('customercode')) return false
      this.$http.get('/api/v1/customer/search/user_center_user_info').then((res) => {
        if (res.cxajaxrc !== 0) return false
        const info = res.returnvalue.userinfo[0]
        this.userInfo = info
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.top {
  height: 66px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .content {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    color: #333;
    align-items: center;
    .tabs {
      display: flex;
      justify-content: space-between;
      width: 390px;
      height: fit-content;
      .tab {
        display: flex;
        flex-direction: column;
        align-items: center;
        min-width: 34px;
        a {
          display: inline-block;
          position: relative;
          padding-bottom: 10px;
          text-align: center;
          text-decoration: none;
          color: #333;
          cursor: pointer;
        }
        hr {
          visibility: hidden;
          color: $mainColor;
        }
        &:hover,
        &.active {
          a {
            color: $mainColor;
          }
          hr {
            visibility: visible;
          }
        }
      }
    }
    .login {
      span,
      a {
        color: #333;
        text-decoration: none;
        position: relative;
        &:nth-of-type(1) {
          margin-right: 10px;
        }
        &:nth-of-type(3) {
          margin-left: 10px;
        }
        &:hover:not(.line) {
          color: $mainColor;
          cursor: pointer;
        }
      }
      a.active {
        color: $mainColor;
      }
      .line {
        padding: 0 5px;
      }
    }
    .popover {
      padding: 0;
    }
  }
}
.is-home {
  padding-top: 40px;
}
</style>
